import React, { useState, useRef } from 'react';
import { Item } from 'devextreme-react/form';
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Lookup,
    Export,   
    Button as ButtonGrid,   
    Editing,
    HeaderFilter,
    Scrolling,
    Popup,     
    Form, 
    RequiredRule,
    StringLengthRule
}
from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import uri from '../../utils/uri';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import { createStoreLocal } from '../../utils/proxy';
import { store } from '../../services/store';
import { cellRender } from '../../utils/common';
import { editorOptionsNumberBox, editorOptionsSelect, editorOptionsSwitch, editorOptsDateBox, editorOptsTextBox, formatDateTime, resources } from '../../data/app';
import { dialogCatalog } from '../../store/catalog/catalogDialogReducer';
import useAuthorization from "../../hooks/useAuthorization";
import NewCatalog from '../products/NewCatalog';
import { ToolbarItem } from 'devextreme-react/popup';
import { useDispatch } from 'react-redux';
import { dateByReport } from '../../data/defaultObjects';
import moment from 'moment';

const Expenses = (props) => {

    const [reload, setReload] = useState(false);

    const [ dates , setDates ] = useState({ 
        from: dateByReport.from,
        to: dateByReport.to
    });

    const [reloadScreen, setReloadScreen] = useState(0);

    let dataGrid = useRef();    

    const dispatch = useDispatch();

    const [ authorized ] = useAuthorization( resources.gestionGastos );

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                
                text: 'Agregar gastos',
                icon:'plus',
                type:'default',
                //stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.addRow()
            }
        },{
            location: 'after',
            widget: 'dxDateBox',
            options: {
                label: 'Desde',
                openOnFieldClick: true,
                displayFormat: 'dd/MM/yyyy',
                width: 180,
                placeholder: 'Desde',
                value: dates.from,
                showClearButton:true,
                onValueChanged: (e) => {
                    setDates({ ...dates, from: e.value });
                }

            }
        }, {
            location: 'after',
            widget: 'dxDateBox',
            options: {
                openOnFieldClick: true,
                displayFormat: 'dd/MM/yyyy',
                width: 180,
                placeholder: 'Hasta',
                value: dates.to,
                showClearButton:true,
                onValueChanged: (e) => {
                    setDates({ ...dates, to: e.value });
                }

            }
        });
    }
  
    const title = 'Registro de Gastos';


    const onInitNewRow = (e) => {
        e.data.active = true; 
        e.data.id = 0; 
    }

    const buttonNewCatalog = {
        text: 'Nueva categoria',
        icon: 'plus',
        onClick: function(e) {
            dispatch(dialogCatalog({ open: true, id: 0 }));
        }
    };

    const buttonActualizar = {
        text: 'Actualizar',
        icon: 'refresh',
        onClick: function(e) { 
            setReloadScreen(reloadScreen + 1);
            setReload(true);
        }
    };

    let extraParameter =[['dateFrom', moment(dates.from).utc().format()], ['dateTo', moment(dates.to).utc().format()]];

    return authorized(
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} showFavorite={true} {...props}>
            </BlockHeader>
            <NewCatalog list={[
                { id: 4, name: 'Categoria' },
            ]} />
            <DataGrid id="gridContainer"
                ref={dataGrid}
                selection={{ mode: 'single' }}
                dataSource={store({uri : uri.expenses, remoteOperations: true, extraParameter })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                onToolbarPreparing={onToolbarPreparing}
                 remoteOperations={{
                    paging: true,
                    filtering: true
                }}
                onInitNewRow={onInitNewRow}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <Export enabled={true} fileName={'Gastos'} allowExportSelectedData={true} />   
                <Column dataField="id" width={80}/>
                <Column dataField="date" caption="Fecha" dataType="date" width={100} format="dd/MM/yyyy" ></Column>
                <Column dataField="categoryId" caption="Categoria" width={220}>
                    <Lookup dataSource={createStoreLocal({name:'expenseCategory', reload })}
                    valueExpr="id"
                    displayExpr="name" />
                    
                </Column>
                <Column dataField="username" width={120} caption="Vendedor">
                    <Lookup dataSource={createStoreLocal({ url: uri.users.base + '/vendors', active: true })} valueExpr="username" displayExpr="fullName" />
                </Column>
                <Column dataField="value" caption="Monto" dataType="number" cellRender={cellRender()} width={100} alignment="right" ></Column>
                <Column dataField="observation" caption="Observación" />
                <Column dataField="createdAt" caption="Creado el" dataType="date" width={160} format={formatDateTime} allowEditing={false} showEditorAlways={false} />
                <Column dataField="createdBy" caption="Creado por" width={100} allowEditing={false} />                             
                <Column dataField="modifiedAt" caption="Modificado el" dataType="date" width={160} format={formatDateTime} allowEditing={false} visible={false} />
                <Column dataField="modifiedBy" caption="Modificado por" width={150} allowEditing={false} visible={false}/>
                <Column dataField="applyCut" caption="Aplica en caja" dataType="boolean" width={80} visible={true}/>
                <Column dataField="active" caption="Activo" dataType="boolean" width={80} visible={false}/>
               
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                    <Popup title={title} showTitle={true} width={700} height={320}>
                        
                        <ToolbarItem
                            widget="dxButton"
                            location="after"
                            options={buttonNewCatalog}>
                        </ToolbarItem>
                        <ToolbarItem
                            widget="dxButton"
                            location="after"
                            options={buttonActualizar}>
                        </ToolbarItem>
                        <ToolbarItem
                            widget="dxButton"
                            location="after"
                            options={
                                {
                                    icon: 'save',
                                    onClick: (e) => {                                        

                                        dataGrid.current.instance.saveEditData()
                                            .then(() => {
                                                //setReloadScreen(reloadScreen + 1);
                                                //setReload(true);
                                            });
                                    }
                                }
                            }>
                        </ToolbarItem>
                    </Popup>
                    <Form>
                        <Item  dataField="date" colSpan={1} editorOptions={editorOptsDateBox}>
                            <RequiredRule message="El campo es requerido"/>
                        </Item>
                        <Item  dataField="categoryId" colSpan={1} editorType="dxSelectBox"
                            editorOptions={editorOptionsSelect} >
                            <RequiredRule message="El campo es requerido"/>
                        </Item>  
                        <Item dataField="username" colSpan={1} editorType="dxSelectBox"
                            editorOptions={{...editorOptionsSelect, valueExpr:"username", displayExpr:"fullName"}} >
                        </Item>
                        <Item dataField="value" colSpan={2} editorType="dxNumberBox" editorOptions={editorOptionsNumberBox}>
                            <RequiredRule message="El campo es requerido"/>
                        </Item>
                        <Item dataField="observation" colSpan={2} editorType="dxTextArea" editorOptions={editorOptsTextBox}>
                            <StringLengthRule max={250} message="Máximo de caracteres 250"/>
                        </Item>
                        <Item dataField="applyCut" colSpan={1} editorType="dxSwitch"
                            editorOptions={editorOptionsSwitch}  >
                        </Item>
                        <Item dataField="active" colSpan={1} editorType="dxSwitch"
                            editorOptions={editorOptionsSwitch}  >
                        </Item>
                    </Form>
                </Editing>
            </DataGrid>
        </div>
    );
}

export default Expenses;
